/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { StandaloneIFrame } from 'components/standaloneIFrame'
import { MetaInfos } from 'components/metaInfos'
import { Link } from '@ta-interaktiv/contentbricks'
import { parseHostname } from '@ta-interaktiv/parse-hostname'
// TODO Set the correct article ID here
const ARTICLE_ID = '378726160093'
console.log('aa')
export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>Was bei der Einreise in die Schweiz zu beachten ist</h1>
            <h2>
              In diesen Ländern sind die Corona-Fallzahlen am höchsten – zum
              Ordnen nach Quarantänepflicht, Staat und Inzidenzwert.
            </h2>
          </div>
        </div>
      </header>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <MetaInfos
            authors={['Interaktiv-Team']}
            updated='Wird täglich aktualisiert'
          />
          <div className='ta text'>
            <p>
              Zurzeit werden keine Staaten und Gebiete mit besorgniserregender
              Virusvariante gelistet. Demnach gilt für die Einreise in die
              Schweiz aktuell keine Test- oder Quarantänepflicht, und auch das
              Einreiseformular muss nicht ausgefüllt werden. Zu beachten sind
              weiterhin die{' '}
              <Link
                allowWordWrap
                href='https://www.sem.admin.ch/sem/de/home/sem/aktuell/faq-einreiseverweigerung.html'
              >
                Einreisebeschränkungen des Staatssekretariats für Migration
                (SEM)
              </Link>
              .
              </p>
          </div>
        </div>
        <div className='ui container'>
          <StandaloneIFrame
            id='quarantaene'
            url={
              'https://interaktiv.' +
              parseHostname().publicationDomain +
              '/2020/quarantaenepflicht-embed/'
            }
          />
        </div>

        {/* <div className='ui text container'>
          <div className='ta text'>
            <p>
              <h4>Was ist zu beachten:</h4>
              Reisende aus den vom BAG bestimmten Ländern müssen:
              <ul>
                <li>
                  sich sofort nach ihrer Ankunft in der Schweiz in eine
                  geeignete Unterkunft begeben
                </li>
                <li>
                  ihre Einreise innerhalb von 2 Tagen den kantonalen Behörden
                  melden
                </li>
                <li>
                  sich 10 Tage in Quarantäne aufhalten und den{' '}
                  <Link
                    allowWordWrap
                    href='https://www.bag.admin.ch/dam/bag/de/dokumente/mt/k-und-i/aktuelle-ausbrueche-pandemien/2019-nCoV/merkblatt-selbstquarantaene.pdf.download.pdf/covid-19_anweisungen_quarantaene.pdf'
                  >
                    Anweisungen zur Quarantäne
                  </Link>{' '}
                  befolgen
                </li>{' '}
                <li>weiteren Anweisungen der Behörden folge leisten</li>
              </ul>
            </p>
          </div>
        </div> */}
      </div>

      <Footer
        articleId={ARTICLE_ID}
        credits={[
          [
            'Konzept und Umsetzung',
            'Marc Brupbacher, Matthias Chapman, Patrick Vögeli, Sebastian Broschinski, Mathias Lutz, Andreas Moor'
          ]
        ]}
        hideUserFeedback
      />
    </div>
  )
}
